// extracted by extract-css-chunks-webpack-plugin
module.exports = {"procedurePreview":"_3IU5rb aLs3Nr","step":"_8t9Jq5","procedurePreviewMobile":"_2lWx66"};